var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHollowCutTwitter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,0C22.4,0,0,22.4,0,50s22.4,50,50,50s50-22.4,50-50S77.6,0,50,0z M76.7,36.4c0.3,9.1-2.3,16.4-5.7,22.1 c-3.3,5.6-7.8,10.1-13.2,13.3c-5.4,3.3-12.6,5.7-21.1,5.4c-7.9-0.2-14.2-2.5-19.3-5.6c-0.3-0.2-0.7-0.4-0.9-0.7 c8.8,1,15.5-1.9,20.3-5.6c-3.5-0.1-6.2-1.3-8.2-3c-2-1.6-3.7-3.8-4.6-6.6c1.8,0.4,4.4,0.3,6-0.2c-3.3-0.7-5.7-2.5-7.6-4.7 c-1.9-2.1-3.2-5-3.2-9c0.1-0.2,0.4,0.1,0.6,0.2c1.5,0.7,3.4,1.3,5.5,1.4c-3.4-2.4-6.8-7-5.8-13.5c0.3-1.9,0.9-3.5,1.7-4.9 c0.9,0.9,1.7,1.9,2.6,2.8C30,34,38,38.5,49.6,39.4c-1.6-7.1,2.1-12.4,6.6-15c2.5-1.4,6-2.1,9.4-1.4c3.1,0.6,5.5,2.2,7.3,4 c3.4-0.6,6.1-1.9,8.7-3.3c-1.2,3.3-3.1,5.9-6,7.5c2.8-0.2,5.5-1.2,7.8-2.1C81.7,32,79.3,34.3,76.7,36.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHollowCutTwitter);
export default __webpack_public_path__ + "static/media/hollow-cut-twitter.102410dd0eb7664797ca3b03af331ce4.svg";
export { ForwardRef as ReactComponent };